export default __webpack_public_path__ + "static/jambb-d14fdbcfd15679ff6c5b7fce3ee08dcb.png";